import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "../../../../hook/use-search-params";
import { DocumentContentService } from "../../../../services/document/document-content.service";
import { useMemo } from "react";

export const useDocumentContentVersion = () => {
  const { searchParams } = useSearchParams();
  const customId = searchParams.get("customId") || "";

  const { data, isLoading } = useQuery({
    queryKey: ["document-content-version", customId],
    queryFn: () => DocumentContentService.getFileId_OldContentVersion(customId),
    enabled: !!customId,
  });

  const selectedPermisison = useMemo(() => {
    const selected = data?.at(data?.length - 1);
    return !selected?.fields?.Permissions ? [] : JSON.parse(selected?.fields?.Permissions);
  }, [data]);

  return { data, isLoading, selectedPermisison };
};
